import { useQuery, UseQueryResult } from 'react-query';
import { FlowTriggerList } from 'types';
import { client } from 'utils/api-client';

function useFlowTriggerList(): UseQueryResult<{ data: FlowTriggerList }> {
  return useQuery('flowTriggerList', () => client.get(`flows/trigger-list`), {});
}

export default useFlowTriggerList;
